import script from "./NewsLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsLayout.vue?vue&type=script&lang=ts&setup=true"

import "./NewsLayout.vue?vue&type=style&index=0&id=0aeaa742&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeaa742"]])

export default __exports__